

export const Bio = () => {
  return (
    <section className="container container-lines">
      <p className="purple-text">
        📚 Projects  <a href="https://github.com/takwa-laffet?tab=repositories">
          <span className="purple-smoke-text">Here are a few works I've worked on recently</span></a>
      </p>
         </section>
  );
};
